import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { transformSDKFloatToRESTFloat } from '@wix/sdk-runtime/transformations/float';
import { transformRESTFloatToSDKFloat } from '@wix/sdk-runtime/transformations/float';
import { transformSDKTimestampToRESTTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveWixMembersAboutV2MembersAboutUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'bo._base_domain_': [
      {
        srcPath: '/members-about-api',
        destPath: '',
      },
      {
        srcPath: '/members/v2/abouts',
        destPath: '/v2/abouts',
      },
    ],
    'wixbo.ai': [
      {
        srcPath: '/members-about-api',
        destPath: '',
      },
      {
        srcPath: '/members/v2/abouts',
        destPath: '/v2/abouts',
      },
    ],
    'wix-bo.com': [
      {
        srcPath: '/members-about-api',
        destPath: '',
      },
      {
        srcPath: '/members/v2/abouts',
        destPath: '/v2/abouts',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/members/v2/abouts',
        destPath: '/v2/abouts',
      },
      {
        srcPath: '/_api/members/v2/abouts',
        destPath: '/v2/abouts',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/_api/members/v2/abouts',
        destPath: '/v2/abouts',
      },
    ],
    _: [
      {
        srcPath: '/_api/members/v2/abouts',
        destPath: '/v2/abouts',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_members_members-about';

/** Creates the "About" section content for a member. */
export function createMemberAbout(payload: object): RequestOptionsFactory<any> {
  function __createMemberAbout({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          {
            path: 'memberAbout.content.nodes.galleryData.items.image.media.duration',
          },
          {
            path: 'memberAbout.content.nodes.galleryData.items.video.media.duration',
          },
          {
            path: 'memberAbout.content.nodes.galleryData.items.video.thumbnail.duration',
          },
          { path: 'memberAbout.content.nodes.galleryData.options.item.ratio' },
          { path: 'memberAbout.content.nodes.imageData.image.duration' },
          { path: 'memberAbout.content.nodes.mapData.mapSettings.lat' },
          { path: 'memberAbout.content.nodes.mapData.mapSettings.lng' },
          { path: 'memberAbout.content.nodes.pollData.poll.image.duration' },
          {
            path: 'memberAbout.content.nodes.pollData.poll.options.image.duration',
          },
          {
            path: 'memberAbout.content.nodes.pollData.design.poll.background.image.duration',
          },
          { path: 'memberAbout.content.nodes.appEmbedData.image.duration' },
          { path: 'memberAbout.content.nodes.videoData.video.duration' },
          { path: 'memberAbout.content.nodes.videoData.thumbnail.duration' },
          { path: 'memberAbout.content.nodes.audioData.audio.duration' },
          { path: 'memberAbout.content.nodes.audioData.coverImage.duration' },
          {
            path: 'memberAbout.content.nodes.layoutData.backgroundImage.media.duration',
          },
          {
            path: 'memberAbout.content.nodes.layoutData.backdropImage.media.duration',
          },
          { path: 'memberAbout.content.nodes.shapeData.shape.duration' },
        ],
      },
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: 'memberAbout.content.metadata.createdTimestamp' },
          { path: 'memberAbout.content.metadata.updatedTimestamp' },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.members.about.v2.member_about',
      method: 'POST' as any,
      methodFqn: 'wix.members.about.v2.MembersAbout.CreateMemberAbout',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixMembersAboutV2MembersAboutUrl({
        protoPath: '/v2/abouts',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              {
                path: 'memberAbout.content.nodes.galleryData.items.image.media.duration',
              },
              {
                path: 'memberAbout.content.nodes.galleryData.items.video.media.duration',
              },
              {
                path: 'memberAbout.content.nodes.galleryData.items.video.thumbnail.duration',
              },
              {
                path: 'memberAbout.content.nodes.galleryData.options.item.ratio',
              },
              { path: 'memberAbout.content.nodes.imageData.image.duration' },
              { path: 'memberAbout.content.nodes.mapData.mapSettings.lat' },
              { path: 'memberAbout.content.nodes.mapData.mapSettings.lng' },
              {
                path: 'memberAbout.content.nodes.pollData.poll.image.duration',
              },
              {
                path: 'memberAbout.content.nodes.pollData.poll.options.image.duration',
              },
              {
                path: 'memberAbout.content.nodes.pollData.design.poll.background.image.duration',
              },
              { path: 'memberAbout.content.nodes.appEmbedData.image.duration' },
              { path: 'memberAbout.content.nodes.videoData.video.duration' },
              {
                path: 'memberAbout.content.nodes.videoData.thumbnail.duration',
              },
              { path: 'memberAbout.content.nodes.audioData.audio.duration' },
              {
                path: 'memberAbout.content.nodes.audioData.coverImage.duration',
              },
              {
                path: 'memberAbout.content.nodes.layoutData.backgroundImage.media.duration',
              },
              {
                path: 'memberAbout.content.nodes.layoutData.backdropImage.media.duration',
              },
              { path: 'memberAbout.content.nodes.shapeData.shape.duration' },
            ],
          },
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'memberAbout.content.metadata.createdTimestamp' },
              { path: 'memberAbout.content.metadata.updatedTimestamp' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __createMemberAbout;
}

/**
 * Updates the "About" section content for a member.
 *
 * Each time the "About" section content is updated, `revision` increments by 1. The existing `revision` must be included when updating the "About" section content. This ensures you're working with the latest "About" section and prevents unintended overwrites.
 */
export function updateMemberAbout(payload: object): RequestOptionsFactory<any> {
  function __updateMemberAbout({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          {
            path: 'memberAbout.content.nodes.galleryData.items.image.media.duration',
          },
          {
            path: 'memberAbout.content.nodes.galleryData.items.video.media.duration',
          },
          {
            path: 'memberAbout.content.nodes.galleryData.items.video.thumbnail.duration',
          },
          { path: 'memberAbout.content.nodes.galleryData.options.item.ratio' },
          { path: 'memberAbout.content.nodes.imageData.image.duration' },
          { path: 'memberAbout.content.nodes.mapData.mapSettings.lat' },
          { path: 'memberAbout.content.nodes.mapData.mapSettings.lng' },
          { path: 'memberAbout.content.nodes.pollData.poll.image.duration' },
          {
            path: 'memberAbout.content.nodes.pollData.poll.options.image.duration',
          },
          {
            path: 'memberAbout.content.nodes.pollData.design.poll.background.image.duration',
          },
          { path: 'memberAbout.content.nodes.appEmbedData.image.duration' },
          { path: 'memberAbout.content.nodes.videoData.video.duration' },
          { path: 'memberAbout.content.nodes.videoData.thumbnail.duration' },
          { path: 'memberAbout.content.nodes.audioData.audio.duration' },
          { path: 'memberAbout.content.nodes.audioData.coverImage.duration' },
          {
            path: 'memberAbout.content.nodes.layoutData.backgroundImage.media.duration',
          },
          {
            path: 'memberAbout.content.nodes.layoutData.backdropImage.media.duration',
          },
          { path: 'memberAbout.content.nodes.shapeData.shape.duration' },
        ],
      },
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: 'memberAbout.content.metadata.createdTimestamp' },
          { path: 'memberAbout.content.metadata.updatedTimestamp' },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.members.about.v2.member_about',
      method: 'PATCH' as any,
      methodFqn: 'wix.members.about.v2.MembersAbout.UpdateMemberAbout',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixMembersAboutV2MembersAboutUrl({
        protoPath: '/v2/abouts/{memberAbout.id}',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              {
                path: 'memberAbout.content.nodes.galleryData.items.image.media.duration',
              },
              {
                path: 'memberAbout.content.nodes.galleryData.items.video.media.duration',
              },
              {
                path: 'memberAbout.content.nodes.galleryData.items.video.thumbnail.duration',
              },
              {
                path: 'memberAbout.content.nodes.galleryData.options.item.ratio',
              },
              { path: 'memberAbout.content.nodes.imageData.image.duration' },
              { path: 'memberAbout.content.nodes.mapData.mapSettings.lat' },
              { path: 'memberAbout.content.nodes.mapData.mapSettings.lng' },
              {
                path: 'memberAbout.content.nodes.pollData.poll.image.duration',
              },
              {
                path: 'memberAbout.content.nodes.pollData.poll.options.image.duration',
              },
              {
                path: 'memberAbout.content.nodes.pollData.design.poll.background.image.duration',
              },
              { path: 'memberAbout.content.nodes.appEmbedData.image.duration' },
              { path: 'memberAbout.content.nodes.videoData.video.duration' },
              {
                path: 'memberAbout.content.nodes.videoData.thumbnail.duration',
              },
              { path: 'memberAbout.content.nodes.audioData.audio.duration' },
              {
                path: 'memberAbout.content.nodes.audioData.coverImage.duration',
              },
              {
                path: 'memberAbout.content.nodes.layoutData.backgroundImage.media.duration',
              },
              {
                path: 'memberAbout.content.nodes.layoutData.backdropImage.media.duration',
              },
              { path: 'memberAbout.content.nodes.shapeData.shape.duration' },
            ],
          },
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'memberAbout.content.metadata.createdTimestamp' },
              { path: 'memberAbout.content.metadata.updatedTimestamp' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __updateMemberAbout;
}

/** Deletes the "About" section content for a member. */
export function deleteMemberAbout(payload: object): RequestOptionsFactory<any> {
  function __deleteMemberAbout({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.members.about.v2.member_about',
      method: 'DELETE' as any,
      methodFqn: 'wix.members.about.v2.MembersAbout.DeleteMemberAbout',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixMembersAboutV2MembersAboutUrl({
        protoPath: '/v2/abouts/{id}',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __deleteMemberAbout;
}

/** Retrieves a member's "About" section content. */
export function getMemberAbout(payload: object): RequestOptionsFactory<any> {
  function __getMemberAbout({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.members.about.v2.member_about',
      method: 'GET' as any,
      methodFqn: 'wix.members.about.v2.MembersAbout.GetMemberAbout',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixMembersAboutV2MembersAboutUrl({
        protoPath: '/v2/abouts/{id}',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              {
                path: 'memberAbout.content.nodes.galleryData.items.image.media.duration',
              },
              {
                path: 'memberAbout.content.nodes.galleryData.items.video.media.duration',
              },
              {
                path: 'memberAbout.content.nodes.galleryData.items.video.thumbnail.duration',
              },
              {
                path: 'memberAbout.content.nodes.galleryData.options.item.ratio',
              },
              { path: 'memberAbout.content.nodes.imageData.image.duration' },
              { path: 'memberAbout.content.nodes.mapData.mapSettings.lat' },
              { path: 'memberAbout.content.nodes.mapData.mapSettings.lng' },
              {
                path: 'memberAbout.content.nodes.pollData.poll.image.duration',
              },
              {
                path: 'memberAbout.content.nodes.pollData.poll.options.image.duration',
              },
              {
                path: 'memberAbout.content.nodes.pollData.design.poll.background.image.duration',
              },
              { path: 'memberAbout.content.nodes.appEmbedData.image.duration' },
              { path: 'memberAbout.content.nodes.videoData.video.duration' },
              {
                path: 'memberAbout.content.nodes.videoData.thumbnail.duration',
              },
              { path: 'memberAbout.content.nodes.audioData.audio.duration' },
              {
                path: 'memberAbout.content.nodes.audioData.coverImage.duration',
              },
              {
                path: 'memberAbout.content.nodes.layoutData.backgroundImage.media.duration',
              },
              {
                path: 'memberAbout.content.nodes.layoutData.backdropImage.media.duration',
              },
              { path: 'memberAbout.content.nodes.shapeData.shape.duration' },
            ],
          },
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'memberAbout.content.metadata.createdTimestamp' },
              { path: 'memberAbout.content.metadata.updatedTimestamp' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __getMemberAbout;
}

/**
 * Retrieves the "About" section content of the current member.
 *
 * >**Note:**
 * >This method requires [visitor or member authentication](https://dev.wix.com/docs/api-reference/articles/authentication/about-identities).
 */
export function getMyMemberAbout(payload: object): RequestOptionsFactory<any> {
  function __getMyMemberAbout({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.members.about.v2.member_about',
      method: 'GET' as any,
      methodFqn: 'wix.members.about.v2.MembersAbout.GetMyMemberAbout',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixMembersAboutV2MembersAboutUrl({
        protoPath: '/v2/abouts/my',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              {
                path: 'memberAbout.content.nodes.galleryData.items.image.media.duration',
              },
              {
                path: 'memberAbout.content.nodes.galleryData.items.video.media.duration',
              },
              {
                path: 'memberAbout.content.nodes.galleryData.items.video.thumbnail.duration',
              },
              {
                path: 'memberAbout.content.nodes.galleryData.options.item.ratio',
              },
              { path: 'memberAbout.content.nodes.imageData.image.duration' },
              { path: 'memberAbout.content.nodes.mapData.mapSettings.lat' },
              { path: 'memberAbout.content.nodes.mapData.mapSettings.lng' },
              {
                path: 'memberAbout.content.nodes.pollData.poll.image.duration',
              },
              {
                path: 'memberAbout.content.nodes.pollData.poll.options.image.duration',
              },
              {
                path: 'memberAbout.content.nodes.pollData.design.poll.background.image.duration',
              },
              { path: 'memberAbout.content.nodes.appEmbedData.image.duration' },
              { path: 'memberAbout.content.nodes.videoData.video.duration' },
              {
                path: 'memberAbout.content.nodes.videoData.thumbnail.duration',
              },
              { path: 'memberAbout.content.nodes.audioData.audio.duration' },
              {
                path: 'memberAbout.content.nodes.audioData.coverImage.duration',
              },
              {
                path: 'memberAbout.content.nodes.layoutData.backgroundImage.media.duration',
              },
              {
                path: 'memberAbout.content.nodes.layoutData.backdropImage.media.duration',
              },
              { path: 'memberAbout.content.nodes.shapeData.shape.duration' },
            ],
          },
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'memberAbout.content.metadata.createdTimestamp' },
              { path: 'memberAbout.content.metadata.updatedTimestamp' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __getMyMemberAbout;
}

/**
 * Creates a query to retrieve a list of "About" sections.
 *
 * The `queryMemberAbouts()` method builds a query to retrieve a list of "About" sections and returns a [`MemberAboutsQueryBuilder`](https://dev.wix.com/docs/sdk/backend-modules/members/members-about/member-abouts-query-builder/eq) object.
 *
 * The returned object contains the query definition, which is typically used to run the query using the [`find()`](https://dev.wix.com/docs/sdk/backend-modules/members/members-about/member-abouts-query-builder/find) method.
 *
 * You can refine the query by chaining `MemberAboutsQueryBuilder` methods onto the query. `MemberAboutsQueryBuilder` methods enable you to sort, filter, and control the results `queryMemberAbouts()` returns.
 *
 * `queryMemberAbouts()` runs with these `MemberAboutsQueryBuilder` defaults, which you can override:
 *
 * - [`limit(50)`](https://dev.wix.com/docs/sdk/backend-modules/members/members-about/member-abouts-query-builder/limit)
 */
export function queryMemberAbouts(payload: object): RequestOptionsFactory<any> {
  function __queryMemberAbouts({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.members.about.v2.member_about',
      method: 'POST' as any,
      methodFqn: 'wix.members.about.v2.MembersAbout.QueryMemberAbouts',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixMembersAboutV2MembersAboutUrl({
        protoPath: '/v2/abouts/query',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              {
                path: 'memberAbouts.content.nodes.galleryData.items.image.media.duration',
              },
              {
                path: 'memberAbouts.content.nodes.galleryData.items.video.media.duration',
              },
              {
                path: 'memberAbouts.content.nodes.galleryData.items.video.thumbnail.duration',
              },
              {
                path: 'memberAbouts.content.nodes.galleryData.options.item.ratio',
              },
              { path: 'memberAbouts.content.nodes.imageData.image.duration' },
              { path: 'memberAbouts.content.nodes.mapData.mapSettings.lat' },
              { path: 'memberAbouts.content.nodes.mapData.mapSettings.lng' },
              {
                path: 'memberAbouts.content.nodes.pollData.poll.image.duration',
              },
              {
                path: 'memberAbouts.content.nodes.pollData.poll.options.image.duration',
              },
              {
                path: 'memberAbouts.content.nodes.pollData.design.poll.background.image.duration',
              },
              {
                path: 'memberAbouts.content.nodes.appEmbedData.image.duration',
              },
              { path: 'memberAbouts.content.nodes.videoData.video.duration' },
              {
                path: 'memberAbouts.content.nodes.videoData.thumbnail.duration',
              },
              { path: 'memberAbouts.content.nodes.audioData.audio.duration' },
              {
                path: 'memberAbouts.content.nodes.audioData.coverImage.duration',
              },
              {
                path: 'memberAbouts.content.nodes.layoutData.backgroundImage.media.duration',
              },
              {
                path: 'memberAbouts.content.nodes.layoutData.backdropImage.media.duration',
              },
              { path: 'memberAbouts.content.nodes.shapeData.shape.duration' },
            ],
          },
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'memberAbouts.content.metadata.createdTimestamp' },
              { path: 'memberAbouts.content.metadata.updatedTimestamp' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __queryMemberAbouts;
}
